import styled from "@emotion/styled";
import { Separator, type SeparatorProps } from "react-aria-components";

interface Props extends SeparatorProps {}

export const StyledSeparator = styled(Separator)<Props>(({ orientation, theme }) => ({
  background: theme.colors.grey.x200,
  height: orientation === "vertical" ? "100%" : "1px",
  width: orientation === "vertical" ? "1px" : "100%",
  margin: orientation === "vertical" ? "0 5px" : "5px 0",
}));
